import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card, Accordion, ThemeProvider } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import '../css/BoxItem.css'; // Tell webpack that Button.js uses these styles
import { drop } from 'lodash';
// import BranchBoxCard from './BranchBoxCard'
import BranchBoxCard from '../containers/comps/BranchBoxCardContainer'
import '../css/BoxItemDropDown.css'


class AccordionItemsUserBranches extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mycheckbox: false
        }
        this.onToggleClick = this.onToggleClick.bind(this)
    }

    onToggleClick(e) {
        this.state.mycheckbox = !this.state.mycheckbox;
    }


    render() {
        return (
            <Card style={{ marginBottom: '10px' }} className="panel panel-default m-0 p-3">
                <Accordion.Toggle as={Card.Header} eventKey={this.props.index + 1} className="p-0 btn btn-accordian">
                    <p>{this.props.name}</p>
                    <div className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href={"#" + this.props.index + 1}>
                    <div class="heading-elements">
                         <ul class="list-inline mb-0">
                            <li><div><FeatherIcon className="iconspacing" icon="chevron-down" size="20" /></div></li>
                            </ul>
                        </div>
                    </div>
                    
                </Accordion.Toggle>
                <Accordion.Collapse id={this.props.index + 1} eventKey={this.props.index + 1} className="panel-collapse collapse in">
                    <Card.Body>
                        {this.props.accordionSubItems.map((el, index) => {                            
                            return (
                                <BranchBoxCard branchID={el.id} branchName={el.branchName} branchNumber={el.branchAccountNumber} branchStatus={el.status} ></BranchBoxCard>
                            )
                        })}
                    </Card.Body>
                </Accordion.Collapse>

            </Card >
        );
    }
}

export default AccordionItemsUserBranches;